var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScreensGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_screens_gradient_svg__mask0_2531_292",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "url(#icon_screens_gradient_svg__paint0_linear_2531_292)",
    d: "M.5.5h23v23H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_screens_gradient_svg__mask0_2531_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17v.5h13v-14h-13V17zm.5 1.5a1.43 1.43 0 01-1.06-.44A1.43 1.43 0 014.5 17V4c0-.416.142-.76.44-1.06A1.43 1.43 0 016 2.5h12c.416 0 .76.142 1.06.44.298.3.44.644.44 1.06v13c0 .416-.142.76-.44 1.06a1.43 1.43 0 01-1.06.44H6z",
    fill: "#001464",
    stroke: "url(#icon_screens_gradient_svg__paint1_linear_2531_292)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#icon_screens_gradient_svg__paint2_linear_2531_292)",
    strokeWidth: 2,
    d: "M10 19v3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#icon_screens_gradient_svg__paint3_linear_2531_292)",
    strokeWidth: 2,
    d: "M14 19v3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.313 8.584l2.874 1.916-2.874 1.916V8.584z",
    fill: "#001464",
    stroke: "url(#icon_screens_gradient_svg__paint4_linear_2531_292)",
    strokeWidth: 0.625
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_screens_gradient_svg__paint0_linear_2531_292",
    x1: -10.41,
    y1: 11.981,
    x2: 29.485,
    y2: 11.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_screens_gradient_svg__paint1_linear_2531_292",
    x1: -2.94,
    y1: 10.486,
    x2: 23.657,
    y2: 10.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_screens_gradient_svg__paint2_linear_2531_292",
    x1: 8.501,
    y1: 17.699,
    x2: 8.535,
    y2: 22.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_screens_gradient_svg__paint3_linear_2531_292",
    x1: 12.501,
    y1: 17.699,
    x2: 12.535,
    y2: 22.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_screens_gradient_svg__paint4_linear_2531_292",
    x1: 8.373,
    y1: 10.496,
    x2: 14.607,
    y2: 10.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgIconScreensGradient as ReactComponent };